import { isCopEnabled } from '../../services/cookieUtils'
import { ToastService } from '../../services/toast.service'
import { getSilentToken } from '../../services/tokenUtils'
import { initPermissionsPrewarm } from './permissionsPrewarm'
import { hideRedirectLoader,showRedirectLoader } from './redirectLoader'
import { initSessionSync, waitForSessionSync } from './sessionSync'
import { fetchCurrentUserAndRedirect } from './userRoleRedirect'

const META_ADMIN_PATH = 'meta[name="cop-admin-path"]'
const META_HOME_PATH = 'meta[name="cop-home-path"]'
const TOKEN_ACQUIRED_EVENT = 'cop:token-acquired'

function readPathsFromDOM(): { adminPath: string; homePath: string } | null {
    const adminPath = document.querySelector(META_ADMIN_PATH)?.getAttribute('content') ?? ''
    const homePath = document.querySelector(META_HOME_PATH)?.getAttribute('content') ?? ''

    if (!adminPath && !homePath) return null

    return { adminPath, homePath }
}

function runRedirect(adminPath: string, homePath: string): void {
    if (!getSilentToken()) return
    if ((window as unknown as { Granite?: { author?: unknown } }).Granite?.author) return
    showRedirectLoader()
    waitForSessionSync()
        .then(() => fetchCurrentUserAndRedirect(adminPath, homePath))
        .catch(err => {
            hideRedirectLoader()
            const message = err instanceof Error ? err.message : 'Unable to load account details. Please try again.'
            ToastService.error(message)
        })
}

export function initSwitchAccountRedirect(): void {
    // Gate: skip all COP permission/current-user/redirect work unless the user
    // is a COP/PowerPortal member (cop_powerportal_flag cookie === 'true').
    if (!isCopEnabled()) return

    initPermissionsPrewarm()

    const paths = readPathsFromDOM()
    if (!paths) return

    const { adminPath, homePath } = paths

    // Open BroadcastChannel so this tab responds to session requests from future new tabs
    initSessionSync()

    if (getSilentToken()) {
        runRedirect(adminPath, homePath)
        return
    }

    document.addEventListener(
        TOKEN_ACQUIRED_EVENT,
        (e: Event) => {
            const detail = (e as CustomEvent<{ accessToken?: string }>).detail
            if (!detail?.accessToken) {
                return
            }
            runRedirect(adminPath, homePath)
        },
        { once: true },
    )
}